/* Livora London: footer column accordion. On mobile, clicking a column heading toggles its
   panel open/closed (CSS grid-row transition does the animation). On desktop a CSS media
   query forces every panel open and disables the button, so this script has no visible
   effect there — it only needs to run once. */
(function () {
  if (window.lvFooterLoaded) return;
  window.lvFooterLoaded = true;

  function initOne(root) {
    if (root.dataset.lvFooterInit) return;
    root.dataset.lvFooterInit = 'true';

    root.querySelectorAll('.lv-footer__column-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-open', !isOpen);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lv-footer]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
